import React from 'react';
import TotalShow from '../../common/TotalShow';
import {
  Util
} from '../../common/index'

type DataT = {
  title?: string
  img?: string
}

interface Iprops {
  data?: Array<DataT>
  pClassName?: string
  location?: string
  has_m2m?: boolean
  total?: string
  hasOwen?: boolean
}

function OtherList(props: Iprops) {
  const {
    pClassName,
    data,
    location,
    has_m2m,
    total,
    hasOwen,
  } = props
  let unik = new Date().valueOf()
  return (
    <div className={`${pClassName}`}>
      {/* {
        has_m2m ? 
          <TotalShow
            total={total}
            lastTitle={hasOwen ? ' houses for you' : ' houses on other platforms'}
          /> : ''
      } */}
      {
        data?.map((item, ind) => {
          return (
            <Util
              isOwen={true}
              key={`${ind + unik}`}
              data={item}
              location={location}
            />
          )
        })
      }
    </div>
  );
}

export default OtherList;
